import { blogContentFun } from '../../../api/blogAPI';
import errorHandle from '../../../utils/errorHandle';

export default async function fetchBlogDetailData(id, setBlogDetails, setLoading) {
    setLoading(true);
    try {
        const blogData = await blogContentFun(id);
        setBlogDetails({
            ...blogData.data[0],
            oldImage: blogData.data[0].image,
            description: blogData.data[0].description.map((item) => ({
                ...item,
                oldImage: item.image
            }))
        });
        // setBlogDetails(blogData.data[0]);
        // setFile(blogData.data[0].image);
        setLoading(false);
    } catch (error) {
        errorHandle(error);
        setLoading(false);
    }
}
